import type { IconSvgObject } from './types';

const GemIcon: IconSvgObject = [
  ["path", { d: "M21.3704 15.1186L12.799 3.11864C12.4044 2.56621 11.5858 2.55913 11.1817 3.10465L2.6328 14.6457C2.28975 15.1088 2.40815 15.7653 2.89137 16.0794L11.4762 21.6595C11.7967 21.8679 12.2079 21.8752 12.5357 21.6786L21.0712 16.5573C21.5717 16.257 21.7097 15.5936 21.3704 15.1186Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2.5L14 14M21.5 16L14 14M12 22L14 14M3 15.5L14 14", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GemIcon;
